import { reactive } from 'vue';

export const columns = [
    { title: 'wbs' },
    { title: '任务名称' },
    { title: '任务最终输出' },
    { title: '发布人' },
    { title: '执行人' },
    { title: '执行' },
    // { title: '持续' },
    { title: '开始日期' },
    { title: '结束日期' },
    { title: '关联' },
    { title: '完成' },
    { title: '工作记录' },
    { title: '所需帮助' },
    { title: '操作' },
];

export const testTable = reactive([{
    actualReleaseEndTime: "2023/10/12",
    actualReleaseStartTime: "2023/10/11",
    assistanceNeeded: "所需帮助",
    completionDegree: "",
    executor: "刘世杰",
    executorId: "",
    id: 1,
    lowerAssociation: null,
    outputResults: '[{"value":"设计3D图纸"},{"value":"工艺设计文档"},{"value":"评审结果"},{"value":"设计2D图纸"}]',
    pid: null,
    projectLifeCycle: "M5 生命周期阶段",
    projectLifeCycleId: "5",
    publisher: "杨里珍",
    releaseEndTime: "2023/10/12",
    releaseStartTime: "2023/10/11",
    scheduledEndTime: "2023/10/12",
    scheduledStartTime: "2023/10/11",
    structureName: "结构部",
    taskName: "测试任务",
    toUsers: "刘世杰",
    upperAssociation: null,
    userId: null,
    username: "杨里珍",
    wbs: "1",
    workRecords: "测试工作记录",
    children: [
        {
            actualReleaseEndTime: "2023/10/12",
            actualReleaseStartTime: "2023/10/11",
            assistanceNeeded: "所需帮助",
            completionDegree: "",
            executor: "董海涛",
            executorId: "",
            id: 2,
            lowerAssociation: null,
            outputResults: '[{"value":"设计3D图纸"},{"value":"工艺设计文档"},{"value":"评审结果"}]',
            pid: null,
            projectLifeCycle: "M5 生命周期阶段",
            projectLifeCycleId: "5",
            publisher: "杨里珍",
            releaseEndTime: "2023/10/12",
            releaseStartTime: "2023/10/11",
            scheduledEndTime: "2023/10/12",
            scheduledStartTime: "2023/10/11",
            structureName: "结构部",
            taskName: "测试任务",
            toUsers: "刘世杰",
            upperAssociation: null,
            userId: null,
            username: "刘世杰",
            wbs: "1.1",
            workRecords: "测试工作记录",
            children: [
                {
                    actualReleaseEndTime: "2023/10/12",
                    actualReleaseStartTime: "2023/10/11",
                    assistanceNeeded: "所需帮助",
                    completionDegree: "",
                    executor: "农工",
                    executorId: "",
                    id: 3,
                    lowerAssociation: null,
                    outputResults: '[{"value":"设计3D图纸"},{"value":"工艺设计文档"},{"value":"评审结果"}]',
                    pid: null,
                    projectLifeCycle: "M5 生命周期阶段",
                    projectLifeCycleId: "5",
                    publisher: "杨里珍",
                    releaseEndTime: "2023/10/12",
                    releaseStartTime: "2023/10/11",
                    scheduledEndTime: "2023/10/12",
                    scheduledStartTime: "2023/10/11",
                    structureName: "结构部",
                    taskName: "测试任务",
                    toUsers: "刘世杰",
                    upperAssociation: null,
                    userId: null,
                    username: "贺工",
                    wbs: "1.1.1",
                    workRecords: "测试工作记录",
                }
            ]
        }
    ]
}, {
    actualReleaseEndTime: "2023/10/12",
    actualReleaseStartTime: "2023/10/11",
    assistanceNeeded: "所需帮助",
    completionDegree: "",
    executor: "术文",
    executorId: "",
    id: 4,
    lowerAssociation: null,
    outputResults: '[{"value":"设计3D图纸"},{"value":"工艺设计文档"},{"value":"评审结果"}]',
    pid: null,
    projectLifeCycle: "M5 生命周期阶段",
    projectLifeCycleId: "5",
    publisher: "杨里珍",
    releaseEndTime: "2023/10/12",
    releaseStartTime: "2023/10/11",
    scheduledEndTime: "2023/10/12",
    scheduledStartTime: "2023/10/11",
    structureName: "结构部",
    taskName: "测试任务",
    toUsers: "刘世杰",
    upperAssociation: null,
    userId: null,
    username: "贺工",
    wbs: "1",
    workRecords: "测试工作记录",
    children: [
        {
            actualReleaseEndTime: "2023/10/12",
            actualReleaseStartTime: "2023/10/11",
            assistanceNeeded: "所需帮助",
            completionDegree: "",
            executor: "薛工",
            executorId: "",
            id: 5,
            lowerAssociation: null,
            outputResults: '[{"value":"设计3D图纸"},{"value":"工艺设计文档"},{"value":"评审结果"}]',
            pid: null,
            projectLifeCycle: "M5 生命周期阶段",
            projectLifeCycleId: "5",
            publisher: "杨里珍",
            releaseEndTime: "2023/10/12",
            releaseStartTime: "2023/10/11",
            scheduledEndTime: "2023/10/12",
            scheduledStartTime: "2023/10/11",
            structureName: "结构部",
            taskName: "测试任务",
            toUsers: "刘世杰",
            upperAssociation: null,
            userId: null,
            username: "丘伟强",
            wbs: "1.1",
            workRecords: "测试工作记录",
            children: [
                {
                    actualReleaseEndTime: "2023/10/12",
                    actualReleaseStartTime: "2023/10/11",
                    assistanceNeeded: "所需帮助",
                    completionDegree: "",
                    executor: "孙工",
                    executorId: "",
                    id: 6,
                    lowerAssociation: null,
                    outputResults: '[{"value":"设计3D图纸"},{"value":"工艺设计文档"},{"value":"评审结果"}]',
                    pid: null,
                    projectLifeCycle: "M5 生命周期阶段",
                    projectLifeCycleId: "5",
                    publisher: "杨里珍",
                    releaseEndTime: "2023/10/12",
                    releaseStartTime: "2023/10/11",
                    scheduledEndTime: "2023/10/12",
                    scheduledStartTime: "2023/10/11",
                    structureName: "结构部",
                    taskName: "测试任务",
                    toUsers: "刘世杰",
                    upperAssociation: null,
                    userId: null,
                    username: "丘工",
                    wbs: "1.1.1",
                    workRecords: "测试工作记录",
                }
            ]
        }
    ]
}]);
